"use client";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "../../../chunk-MMUBH76A.js";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { Heading, InnerStepContainer } from "../common.js";
import { CpslText } from "@getpara/react-components";
import { useAddFunds } from "./AddFundsContext.js";
import { useModalStore, useThemeStore } from "../../stores/index.js";
import { motion, AnimatePresence } from "framer-motion";
import { OnRampProviderButton } from "../OnRampComponents/OnRampProviderButton.js";
import { useActiveWallet } from "../../hooks/useActiveWallet.js";
import { EnabledFlow, OnRampProvider, OnRampPurchaseType } from "@getpara/web-sdk";
import { ModalStep } from "../../utils/steps.js";
import { contentMotionProps } from "./common.js";
import { useInternalClient } from "../../../provider/hooks/utils/useInternalClient.js";
function AddFundsProvider() {
  const para = useInternalClient();
  const hideWallets = useThemeStore((state) => state.hideWallets);
  const onRampConfig = useModalStore((state) => state.onRampConfig);
  const setOnRampPurchase = useModalStore((state) => state.setOnRampPurchase);
  const setModalStep = useModalStore((state) => state.setStep);
  const { asset, network, fiatQuantity, isProviderAllowed, tab } = useAddFunds();
  const activeWallet = useActiveWallet();
  return /* @__PURE__ */ jsxs(Container, __spreadProps(__spreadValues({}, contentMotionProps), { children: [
    /* @__PURE__ */ jsx(Heading, { variant: "headingS", weight: "bold", children: "Choose Provider" }),
    /* @__PURE__ */ jsxs($InnerStepContainer, { children: [
      /* @__PURE__ */ jsxs(NoProviders, { isHidden: Object.values(isProviderAllowed).some((v) => !!v), variant: "bodyM", children: [
        "No providers are available for this ",
        hideWallets ? "account" : "wallet"
      ] }),
      /* @__PURE__ */ jsx(AnimatePresence, { children: onRampConfig.providers.map((id, index) => {
        return isProviderAllowed[id] ? /* @__PURE__ */ jsx(
          motion.div,
          {
            style: { width: "100%" },
            layout: true,
            initial: { opacity: 0, transform: "translateX(25px)" },
            animate: { opacity: 1, transform: "none" },
            exit: { opacity: 0, transform: "translateX(-25px)" },
            transition: { duration: 0.2 },
            children: /* @__PURE__ */ jsx(
              OnRampProviderButton,
              {
                config: onRampConfig,
                index,
                onClick: () => __async(this, null, function* () {
                  if (!(activeWallet == null ? void 0 : activeWallet.type)) return;
                  const isPopup = id !== OnRampProvider.RAMP;
                  const { onRampPurchase: newOnRampPurchase } = yield para.initiateOnRampTransaction({
                    walletId: activeWallet.isExternal ? void 0 : activeWallet.id,
                    externalWalletAddress: activeWallet.isExternal ? activeWallet.id : void 0,
                    shouldOpenPopup: isPopup,
                    params: {
                      type: tab === EnabledFlow.BUY ? OnRampPurchaseType.BUY : OnRampPurchaseType.SELL,
                      walletType: activeWallet.type,
                      provider: id,
                      network,
                      asset,
                      fiatQuantity,
                      testMode: onRampConfig.testMode
                    }
                  });
                  setOnRampPurchase(__spreadProps(__spreadValues({}, newOnRampPurchase), { fiat: "USD" }));
                  !isPopup && setModalStep(ModalStep.ADD_FUNDS_AWAITING);
                })
              },
              id
            )
          },
          id
        ) : null;
      }) })
    ] })
  ] }));
}
const Container = styled(motion.div)`
  width: 100%;
  height: 100%;
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  height: 320px;
`;
const $InnerStepContainer = styled(InnerStepContainer)`
  position: relative;
`;
const NoProviders = styled(CpslText)`
  width: 100%;
  text-align: center;
  visibility: ${({ isHidden }) => isHidden ? "hidden" : "visible"};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  transition: visibility 0.2s;
`;
export {
  AddFundsProvider
};
